<template>
  <div>
    <v-card flat class="py-0 mx-4 my-6">
      <v-tabs v-model="tab">
        <v-tab
          v-for="(item, index) in expansionPanels"
          class="text-none black--text"
          :class="index === tab ? 'white primary--text' : ''"
          :key="item.title"
        >
          {{ $t(item.title) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in expansionPanels" :key="item.title">
          <v-card flat>
            <v-card-text v-if="item.table === 'AREA'">
              <area-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'FACILITY'">
              <facility-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'BLOCKS'">
              <block-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'UNIT_TYPE'">
              <unit-type-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'CONTACT_US'">
              <contact-form />
            </v-card-text>
            <v-card-text v-if="item.table === 'CURRENCY'">
              <currency-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'DEFUALT_PROMOTION'">
              <default-promotion-form />
            </v-card-text>
            <v-card-text v-if="item.table === 'LANDLORD_VALIDITY_PLAN'">
              <landlord-validity-plan-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'LANDMARK'">
              <landmark-data-table />
            </v-card-text>
            <v-card-text v-if="item.table === 'FEE'">
              <default-promotion-form />
              <v-divider class="primary"></v-divider>
              <fee-data-table />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <v-expansion-panels
      flat
      class="py-0 my-0 ps-md-3 pe-md-3"
      v-model="panel"
      multiple
    >
      <v-expansion-panel class="my-5 px-0 mx-0" v-for="(item, index) in expansionPanels" :key="index">
        <v-expansion-panel-header>
          <template v-slot:actions>
            <v-icon color="primary"> mdi-chevron-down </v-icon>
          </template>
          <v-container fluid>
            <v-row class="justify-space-between ma-0">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t(item.title) }}
              </h3>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="item.table === 'AREA'"
                :label="$t('common.search')"
                v-model="search"
                 @click.native.stop
                @input="searchTable(item.table)"
                class="mx-2"
                outlined
                dense>
              </v-text-field>
              <v-text-field
                v-if="item.table === 'FACILITY'"
                :label="$t('common.search')"
                v-model="search1"
                 @click.native.stop
                @input="searchTable(item.table)"
                class="mx-2"
                outlined
                dense>
              </v-text-field>
              <v-text-field
                v-if="item.table === 'BLOCKS'"
                :label="$t('common.search')"
                v-model="search2"
                 @click.native.stop
                @input="searchTable(item.table)"
                class="mx-2"
                outlined
                dense>
              </v-text-field>
              <v-btn
                outlined
                @click="exportData(item.table)"
                @click.native.stop
                :class="!$vuetify.breakpoint.smAndUp ? 'my-2'  : ''"
                class="primary mx-2 white--text custom-button"
              >
                <v-icon small class="mx-2">
                  mdi-application-export
                </v-icon>
                {{
                  $t("common.excel")
                }}
              </v-btn>
              <v-btn
                @click.native.stop
                v-if="item.btnTitle"
                class="custom-button text-none"
                @click="showRightSideDrawer(item.table)"
                depressed
              >
                <v-icon size="20" left>mdi-plus</v-icon>
                {{ $t(item.btnTitle) }}
              </v-btn>
            </v-row>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-if="item.table === 'AREA'"><area-data-table/></template>
          <template v-if="item.table === 'FACILITY'"><facility-data-table/></template>
          <template v-if="item.table === 'BLOCKS'"><block-data-table/></template>
          <template v-if="item.table === 'UNIT_TYPE'"><unit-type-data-table/></template>
          <template v-if="item.table === 'CONTACT_US'"><contact-form/></template>
          <template v-if="item.table === 'DEFUALT_PROMOTION'"><default-promotion-form/></template>
          <template v-if="item.table === 'LANDMARK'"><landmark-data-table/></template>
          <template v-if="item.table === 'FEE'">
            <default-promotion-form/>
            <fee-data-table/></template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels> -->
    <side-drawer>
      <template slot="formDetails">
        <template v-if="appSettingFormName === 'AREA'"><area-form /></template>
        <template v-if="appSettingFormName === 'FACILITY'"
          ><facility-form
        /></template>
        <template v-if="appSettingFormName === 'BLOCKS'"
          ><block-form
        /></template>
        <template v-if="appSettingFormName === 'UNIT_CATEGORY'"
          ><unit-form
        /></template>
        <template v-if="appSettingFormName === 'CONTACT_US'"
          ><contact-form
        /></template>
        <template v-if="appSettingFormName === 'CURRENCY'"
          ><currency-form
        /></template>
        <template v-if="appSettingFormName === 'DEFUALT_PROMOTION'"
          ><default-promotion-form
        /></template>
        <template v-if="appSettingFormName === 'LANDLORD_VALIDITY_PLAN'"
          ><landlord-validity-plan-form
        /></template>
        <template v-if="appSettingFormName === 'LANDMARK'"
          ><landmark-form
        /></template>
        <template v-if="appSettingFormName === 'FEE'">
          <fee-form />
        </template>
      </template>
    </side-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      panel: [0, 1],
      tab: Number(localStorage.getItem("settingTab")) || 0,
      search: null,
      search1: null,
      search2: null,
      search3: null,
      search4: null
    };
  },
  watch: {
    tab(val) {
      localStorage.setItem("settingTab", val);
    }
  },
  components: {
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "area-data-table": () => import("@/settings/components/AreaDataTable.vue"),
    "facility-data-table": () =>
      import("@/settings/components/FacilityDataTable.vue"),
    // 'contact-data-table': () => import("@/settings/components/ContactDataTable.vue"),
    "block-data-table": () =>
      import("@/settings/components/BlocksDataTable.vue"),
    "block-form": () =>
      import("@/settings/components/rightSideDrawer/BlocksForm.vue"),
    "landmark-data-table": () =>
      import("@/settings/components/LandmarkDataTable.vue"),
    "landmark-form": () =>
      import("@/settings/components/rightSideDrawer/LandmarkForm.vue"),
    "fee-data-table": () => import("@/settings/components/FeeDataTable.vue"),
    "area-form": () =>
      import("@/settings/components/rightSideDrawer/AreaForm.vue"),
    "facility-form": () =>
      import("@/settings/components/rightSideDrawer/FacilityForm.vue"),
    "contact-form": () =>
      import("@/settings/components/rightSideDrawer/ContactForm.vue"),
    "default-promotion-form": () =>
      import("@/settings/components/rightSideDrawer/DefualtPromotionForm.vue"),
    "fee-form": () =>
      import("@/settings/components/rightSideDrawer/FeeForm.vue"),
    "currency-form": () =>
      import("@/settings/components/rightSideDrawer/CurrencyForm.vue"),
    "currency-data-table": () =>
      import("@/settings/components/CurrencyDataTable.vue"),
    "landlord-validity-plan-form": () =>
      import(
        "@/settings/components/rightSideDrawer/LandlordValidityPlanForm.vue"
      ),
    "landlord-validity-plan-data-table": () =>
      import("@/settings/components/LandlordValidityPlanDataTable.vue")
  },
  computed: {
    ...mapGetters(["appSettingFormName"]),
    expansionPanels() {
      return [
        // {
        //   title: "settings.area.title",
        //   btnTitle: "settings.area.btnTitle",
        //   export: true,
        //   table: "AREA"
        // },
        // {
        //   title: "settings.blocks.title",
        //   btnTitle: "settings.blocks.btnTitle",
        //   export: true,
        //   table: "BLOCKS"
        // },
        // {
        //   title: "settings.landmark.title",
        //   btnTitle: "settings.landmark.btnTitle",
        //   export: true,
        //   table: "LANDMARK"
        // },
        // {
        //   title: "settings.facility.title",
        //   btnTitle: "settings.facility.btnTitle",
        //   export: true,
        //   table: "FACILITY"
        // },
        // { title: 'Default Promotion Charge', btnTitle: null, export: false, table: 'DEFUALT_PROMOTION' },
        // {
        //   title: "settings.promotionCharge.title",
        //   btnTitle: "settings.promotionCharge.btnTitle",
        //   export: false,
        //   table: "FEE"
        // },
        {
          title: "settings.currency.title",
          btnTitle: "settings.currency.btnTitle",
          export: true,
          table: "CURRENCY"
        },
        // {
        //   title: "settings.landlordValidityPlan.title",
        //   btnTitle: "settings.landlordValidityPlan.btnTitle",
        //   export: true,
        //   table: "LANDLORD_VALIDITY_PLAN"
        // },
        // {
        //   title: "settings.contactUs.title",
        //   btnTitle: null,
        //   export: false,
        //   table: "CONTACT_US"
        // }
        // 'settings.contactUs.btnTitle' settings.fee.title settings.fee.btnTitle
        // { title: 'settings.privacyPolicies.title', btnTitle: null, table: 'PRIVATE' },
      ];
    }
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData(item) {
      switch (item) {
        case "AREA":
          this.$root.$emit("exportArea");
          break;
        case "FACILITY":
          this.$root.$emit("exportFacility");
          break;
        case "BLOCKS":
          this.$root.$emit("exportBlocks");
          break;
        case "LANDMARK":
          this.$root.$emit("exportLandmark");
          break;
        case "CURRENCY":
          this.$root.$emit("exportCurrency");
          break;
        case "LANDLORD_VALIDITY_PLAN":
          this.$root.$emit("exportLandlordValidityPlan");
          break;
      }
    },
    searchTable(item) {
      switch (item) {
        case "AREA":
          this.$root.$emit("searchArea", this.search);
          break;
        case "FACILITY":
          this.$root.$emit("searchFacility", this.search1);
          break;
        case "BLOCKS":
          this.$root.$emit("searchBlocks", this.search2);
          break;
        case "CURRENCY":
          this.$root.$emit("searchCurrency", this.search3);
          break;
        case "LANDLORD_VALIDITY_PLAN":
          this.$root.$emit("searchLandlordValidityPlan", this.search4);
          break;
      }
    }
  }
};
</script>

<style></style>
